import type { FormInstance } from 'antd';
import { Divider, Form } from 'antd';

import { Mode } from 'app/components/commons/Hotel/Types';
import { Pictures } from 'app/components/commons/Package/Pictures/Pictures';
import { UploadList } from 'app/components/commons/Uploader/UploadList/UploadList';
import type { HotelDiscover } from 'app/typings/hotels/Hotel/HotelDiscover';

import './Discover.scss';
import { ExperienceList } from './ExperienceList/ExperienceList';

export const Discover = ({
  mode,
  hotelId,
  values,
  setIsDirtyMove,
  form,
  isLegacy = false,
}: {
  mode: Mode;
  hotelId: number;
  values: Pick<HotelDiscover, 'introPictures' | 'roomPictures' | 'experiences'>;
  setIsDirtyMove: (value: boolean) => void;
  form: FormInstance;
  isLegacy?: boolean;
}) => {
  return (
    <>
      <div className="staycation-discover-card__container">
        <div className="staycation-discover-card__title">Introduction</div>
        <Form.Item name="introPictures">
          {mode === Mode.Edit ? (
            <Pictures
              sectionTitle="Introduction"
              hotelId={hotelId}
              picturesCategories={[
                { name: 'Official', type: 'official' },
                { name: 'Sourcing', type: 'sourcing' },
              ]}
              kind="sourcing"
              editable
              draggable
              removable
              modalSubtitle="Select photos or upload new ones to illustrate the intro part"
            />
          ) : (
            <UploadList
              pictures={values?.introPictures || []}
              uploadingItems={{}}
              previewable
            />
          )}
        </Form.Item>
      </div>

      <Divider />

      <ExperienceList
        experiences={values.experiences}
        setIsDirtyMove={setIsDirtyMove}
        mode={mode}
        form={form}
        isLegacy={isLegacy}
      />

      <Divider />

      <div className="staycation-discover-card__container">
        <div className="staycation-discover-card__title">Rooms</div>
        <Form.Item name="roomPictures">
          {mode === Mode.Edit ? (
            <Pictures
              sectionTitle="Room"
              hotelId={hotelId}
              picturesCategories={[{ name: 'Photos List', type: 'sourcing' }]}
              kind="sourcing"
              editable
              draggable
              removable
              modalSubtitle="Select photos or upload new ones to illustrate the rooms"
              fetchRooms
            />
          ) : (
            <UploadList
              pictures={values?.roomPictures || []}
              uploadingItems={{}}
              previewable
            />
          )}
        </Form.Item>
      </div>
    </>
  );
};
